/* @ngInject */

export default ($rootScope, dateTimeService) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function AssetFinanceProposalAmortizationSchedule(
    repayment,
    isRepaymentEdited,
    beginningBalance,
    principalReduction,
    interestPaid,
    interestDeferred,
    endingBalance,
    paymentDate
  ) {
    this.repayment = repayment;
    this.isRepaymentEdited = isRepaymentEdited;
    this.beginningBalance = beginningBalance;
    this.principalReduction = principalReduction;
    this.interestPaid = interestPaid;
    this.interestDeferred = interestDeferred;
    this.endingBalance = endingBalance;
    this.paymentDate = paymentDate;
  }

  /*
   * Static Methods
   * --------------------------------------------------------------------------------
   */
  AssetFinanceProposalAmortizationSchedule.Blank = function (paymentDate) {
    return AssetFinanceProposalAmortizationSchedule.Build({
      repayment: 0,
      isRepaymentEdited: false,
      beginningBalance: 0,
      principalReduction: 0,
      interestPaid: 0,
      interestDeferred: 0,
      endingBalance: 0,
      paymentDate: paymentDate || dateTimeService.epoch()
    });
  };

  AssetFinanceProposalAmortizationSchedule.Build = function (data) {
    return new AssetFinanceProposalAmortizationSchedule(
      parseFloat(data.repayment || 0) || 0,
      data.isRepaymentEdited || false,
      parseFloat(data.beginningBalance || 0) || 0,
      parseFloat(data.principalReduction || 0) || 0,
      parseFloat(data.interestPaid || 0) || 0,
      parseFloat(data.interestDeferred || 0) || 0,
      parseFloat(data.endingBalance || 0) || 0,
      data.paymentDate || dateTimeService.epoch()
    );
  };

  /*
   * Public methods
   * --------------------------------------------------------------------------------
   */
  AssetFinanceProposalAmortizationSchedule.prototype.getPaymentDate = function () {
    return dateTimeService.getFormattedDate(this.paymentDate);
  };
  AssetFinanceProposalAmortizationSchedule.prototype.deleteDateObject = function () {
    delete this.paymentDateObject;
  };

  return AssetFinanceProposalAmortizationSchedule;
};
